import { AuthService } from './../../shared/models/auth.service';
import { TemplateModel } from './template.model';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';


@Injectable()
export class TemplateService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetTemplateList(input?: DataListModel): Observable<IAPIResponse> {
    let getTemplateListUrl = WeGoConfig.API_GET_TEMPLATE_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getTemplateListUrl = getTemplateListUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getTemplateListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetTemplateByHashId(templateHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_GET_TEMPLATE_BY_HASH + "?templateHashId=" + templateHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSampleTemplateByHashId(templateHashId: string, bodyHtml: string): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_GET_SAMPLE_TEMPLATE_BY_HASH;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let body = new TemplateModel();
    body.templateHashID = templateHashId;
    body.bodyHTml = bodyHtml;
    return this.http.post(getInstanceUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateTemplate(templateModel: TemplateModel): Observable<IAPIResponse> {
    let body = templateModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.post(WeGoConfig.API_POST_TEMPLATE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetTemplateNameList(customerHashId: string,instanceHashId?: string,companyHashId?: string,organizationHashId?: string,svgHashId?: string): Observable<IAPIResponse> {
    let getTemplateNameListUrl = WeGoConfig.API_GET_TEMPLATE_NAME_LIST + "?customerHashId=" + customerHashId;;
    
    if(instanceHashId){
      getTemplateNameListUrl = getTemplateNameListUrl + "&instanceHashId=" + instanceHashId;
    }

    if(companyHashId){
      getTemplateNameListUrl = getTemplateNameListUrl + "&companyHashId=" + companyHashId;
    }

    if(organizationHashId){
      getTemplateNameListUrl = getTemplateNameListUrl + "&organizationHashId=" + organizationHashId;
    }

    if(svgHashId){
      getTemplateNameListUrl = getTemplateNameListUrl + "&svgHashId=" + svgHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getTemplateNameListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetMasterTemplateByHashId(templateNameHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_GET_MASTER_TEMPLATE_BY_HASH + "?templateNameHashId=" + templateNameHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  // public GetTemplateInstanceList(templateNameHashId: string): Observable<IAPIResponse> {
  //   let getInstanceUrl = WeGoConfig.API_GET_UNUSED_INSTANCE_LIST_FOR_TEMPLATE + "?templateNameHashId=" + templateNameHashId;
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });
  //   return this.http.get(getInstanceUrl, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  public DeleteTemplates(selectedTemplates: string[]): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_DELETE_TEMPLATES, selectedTemplates, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GenerateLatexSamplePDF(templateHashId: string, instanceHashId: string, bodyHtml: string): any {

    let getInstanceUrl = WeGoConfig.API_GENERATE_LATEX_PDF_BY_HASH;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let body = new TemplateModel();
    body.templateHashID = templateHashId;
    body.instanceHashId = instanceHashId;
    body.bodyHTml = bodyHtml;
    return this.http.post(getInstanceUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);

  }


  public DownloadLatexSamplePDF(FileName: string): any {
    let getInvoiceUrl = WeGoConfig.API_DOWNLAOD_LATEX_PDF_BY_HASH + "?FileName=" + FileName;
    let headers = this.authService.GetHeader('application/pdf');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getInvoiceUrl, options);

  }

  public GetTemplateRecipients(customerHashId: string,emailTemplateNameHashId:string): Observable<IAPIResponse> {
    let getRecipientsUrl = WeGoConfig.API_GET_TEMPLATE_NAME_RECIPIENT_LIST + "?customerHashId=" + customerHashId + "&emailTemplateNameHashId=" + emailTemplateNameHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getRecipientsUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/template/models/template.service.ts